import { createRouter, createWebHashHistory } from 'vue-router'
import hooks from './hooks'

// 初始静态路由
const routes = [
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/views/layout/layout.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: {
          title: ''
        }
      },
      {
        path: '/detail',
        name: 'Detail',
        component: () => import('@/views/detail/index.vue'),
        meta: {
          title: '详情页'
        }
      },
      {
        path: '/donate',
        name: 'Donate',
        component: () => import('@/views/donate/index.vue'),
        meta: {
          title: '我要捐赠'
        }
      },
      {
        path: '/donate-detail',
        name: 'DonateDetail',
        component: () => import('@/views/donate/donateDetail.vue'),
        meta: {
          title: '项目详情'
        }
      },
      {
        path: '/search-detail',
        name: 'searchDetail',
        component: () => import('@/views/search/index.vue'),
        meta: {
          title: '项目详情'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach(hooks.beforeEach)
router.afterEach(hooks.afterEach)

export default router 
